export { default } from './SVGIcon';